@if (hisBaseGlobalsService.dataDictionaryEditMode() && ddIdentifier) {
    <div class="metadata_popup_text" #popupRef>
        @if (ddIdentifier) {
            <strong>DataDict. Key:</strong> {{ddIdentifier}}<br>
            <strong>Applied Contexts:</strong><br>
            @for (context of getAppliedContexts(); track context) {
                <em>{{context}}</em>
                @for (confSrc of getConfSrcsForContext(context); track confSrc) {
                    <a href="#"
                    (click)="openDatadictionaryExistingConfigEditPopup(ddIdentifier, context, confSrc); $event.preventDefault();">{{isConfSrcReadonly(confSrc) ? 'Show' : 'Edit'}} {{confSrc}}</a>
                }
                <a href="#"
                (click)="openDatadictionaryEditPopup(ddIdentifier, context); $event.preventDefault();">Add Config</a><br>
            }
            <strong>Resulting config. for this field:</strong> {{getEffectiveConfigSummary()}} <br>
        }
        @if (dataSource) {
            <strong>Data-Source:</strong> {{dataSource}}
        }
    </div>
}
